export default __webpack_public_path__ + "static/media/export.df6ee25c.svg";